/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS pseudo-selector keys use semantic ordering */
// MUI v4 TextField root-level overrides (host wrapper).
//
// Width strategy: out-of-the-box width-pariteit met Tractie's TractieInput.
// Tractie's host expands to fill its container; MUI's MuiTextField is by
// default `display: inline-block` with intrinsic content-width (~191px for a
// single-line outlined input). For pixel-parity in comparison-grids and
// production form-flows where developers do NOT set `fullWidth` explicitly,
// MuiTextField-root must also expand to fill its container.
//
// This override applies to all variants (outlined / filled / standard / multiline)
// and is merged via the MuiTextFieldLightOverrides / DarkOverrides aggregator
// in theme-overrides.ts.
//
// See foundation-report at scratch/bz0s-B-atoms/text-field/foundation-report.md
// for the visual verification (T1.4, 2026-05-22).

export const MuiTextFieldRootLightOverrides = {
  root: {
    width: '100%',
  },
} as const;

export const MuiTextFieldRootDarkOverrides = {
  ...MuiTextFieldRootLightOverrides,
} as const;
